import { Translate as $t } from "@/plugins/translate";

export enum ResidentConstraints {
  BUILDING = "BUILDING",
  VILLA = "VILLA",
}

export const ResidentTextConstraints = {
  BUILDING: $t("building"),
  VILLA: $t("villa"),
};

export const ResidentTransIndextConstraints = {
  BUILDING: "building",
  VILLA: "villa",
};

export enum SELECTED_ADDRESS {
  NO_ADDRESS = "NO_ADDRESS",
}
